module.exports = __webpack_public_path__ + "media/images/linyalinya-e0a55efae3b94f2a014bff1f4ac6e840.png";